import { isNil } from 'es-toolkit';

import { apiHost } from '../api/api-host';
import { LocalStorage } from './local-storage';
import { isSafeDownloadUrl } from './routing/is-safe-download-url';

function resolveDownloadUrl(relativeOrAbsoluteUrl: string): string {
  if (relativeOrAbsoluteUrl.startsWith('http://') || relativeOrAbsoluteUrl.startsWith('https://')) {
    return relativeOrAbsoluteUrl;
  }
  const path = relativeOrAbsoluteUrl.startsWith('/') ? relativeOrAbsoluteUrl : `/${relativeOrAbsoluteUrl}`;
  return `${apiHost}${path}`;
}

function sanitizeFilename(filename: string): string {
  return filename.replace(/[/\\]/g, '_').replace(/^\.+/, '');
}

export async function downloadWithAuth(urlPath: string, filename: string): Promise<void> {
  const fullUrl = resolveDownloadUrl(urlPath);

  // SECURITY: Validate the resolved URL before attaching auth tokens
  if (!isSafeDownloadUrl(fullUrl, apiHost)) {
    throw new Error('Cannot download from untrusted URL. Please contact support if this error persists.');
  }

  const accessToken = await LocalStorage.getItem('accessToken');

  const response = await fetch(fullUrl, {
    method: 'GET',
    credentials: 'include',
    headers: {
      ...(!isNil(accessToken) && accessToken !== '' ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
  });

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status} ${response.statusText}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = sanitizeFilename(filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
